module.exports = __webpack_public_path__ + "static/omotola-257ba3709821b64603f9d830207f08a9.png";